import cookies from "./lib/cookies";
var dataLayer = window.dataLayer;
cookies(dataLayer, window.cookies);
if (dataLayer && 'gtag' in window) {
    cookies(dataLayer, window.cookies);
}
